// Module
var code = "<div style=\"text-align:center\"> <!-- ko with: _isFavorite --> <i class=\"fa fa-star\"></i> <!-- /ko --> </div>";
// Exports
export default code;